import { get, post, put, del } from './_httpClient';

export async function addInstitutions({
  institutionTypeId,
  institutionName,
  institutionProfile,
  institutionDomicilies = [],
  leadInstitutionTypeId,
  leadInstitutionClusterType,
  leadInstitutionClusterFocus,
  registrationNumber,
  establishmentYear,
  bumdesType,
}) {
  const { status, message, data } = await post('/clp/institutions', {
    institutionTypeId,
    institutionName,
    institutionProfile,
    institutionDomicilies,
    leadInstitutionTypeId,
    leadInstitutionClusterType,
    leadInstitutionClusterFocus,
    registrationNumber,
    establishmentYear,
    bumdesType,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getInstitutions({ filterBy = '', typeId = '', batchId }) {
  const { status, message, data } = await get(
    `/clp/institutions?filterBy=${filterBy}&typeId=${typeId}&batchId=${batchId}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getInstitutionsOptions({ batchId }) {
  const { status, message, data } = await get(
    `/clp/registrations/institutions-options?batchId=${batchId}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getInstitutionsDivisionOptions({ institutionId, batchId }) {
  const { status, message, data } = await get(
    `/clp/registrations/institutions/${institutionId}/division-options?batchId=${batchId}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getInstitutionDetailById({ id }) {
  const { status, message, data } = await get(`/clp/institutions/${id}/detail`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateInstitution(id, payload) {
  const { status, message } = await put(`/clp/institutions/${id}`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function deleteInstitution(id, { isForce = false } = {}) {
  const query = isForce ? '?isForce=true' : '';
  const { status, message, canForce, details } = await del(`/clp/institutions/${id}${query}`);
  if (status !== 'success') {
    const error = new Error(message);
    error.canForce = canForce;
    error.details = details;
    throw error;
  }
  return message;
}

export async function getInstitutionProvinces({ batchId }) {
  const { status, message, data } = await get(`/clp/institutions-provincies?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getInstitutionById({ id, batchId, filterBy = '' }) {
  const { status, message, data } = await get(
    `/clp/institutions/${id}?batchId=${batchId}&filterBy=${filterBy}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getDivisions() {
  const { status, message, data } = await get('/clp/divisions');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addMasterDivision({ name }) {
  const { status, message, data } = await post('/clp/divisions', { name });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateMasterDivision({ id, name }) {
  const { status, message } = await put(`/clp/divisions/${id}`, { name });
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function deleteMasterDivision({ id }) {
  const { status, message } = await del(`/clp/divisions/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function addDivisionByInstitution({ id, payload }) {
  return post(`/clp/institutions/${id}/divisions`, payload);
}

export async function getDivisionsByInstitution({ institutionsId, divisionInstitutionsId }) {
  return get(`/clp/institutions/${institutionsId}/divisions/${divisionInstitutionsId}`);
}

export async function getDivisionInstitutionDetail({ institutionsId, divisionInstitutionsId }) {
  const { status, message, data } = await get(
    `/clp/institutions/${institutionsId}/divisions/${divisionInstitutionsId}/detail`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateDivisionByInstitution({
  institutionsId,
  divisionInstitutionsId,
  payload,
}) {
  return put(`/clp/institutions/${institutionsId}/divisions/${divisionInstitutionsId}`, payload);
}

export async function getDivisionByInstitutionId({ id, batchId }) {
  const { status, message, data } = await get(
    `/clp/institutions/${id}/divisions?batchId=${batchId}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}
